var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        entity: _vm.numberPool,
        title: _vm.$t("DELETE_NUMBER_POOL_MODAL_TITLE"),
        "cancel-button-text": _vm.$t("DELETE_NUMBER_POOL_MODAL_CANCEL_ACTION"),
        "confirm-action-text": _vm.$t(
          "DELETE_NUMBER_POOL_MODAL_CONFIRM_ACTION"
        ),
        "confirm-button-loading": _vm.loadingDeletingNumberPool,
        "confirm-button-disabled":
          _vm.loadingDeletingNumberPool || _vm.loadingNumberPoolReferences,
        "cancel-button-disabled": _vm.loadingDeletingNumberPool
      },
      on: { confirm: _vm.confirmDelete, close: _vm.closeDeleteModal }
    },
    [
      _vm.loadingNumberPoolReferences
        ? _c(
            "div",
            [
              _c("Loader", { attrs: { "custom-class": "size-sm" } }),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("CHECK_NUMBER_POOL_REFERENCES")))
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.hasReferences && !_vm.loadingNumberPoolReferences
        ? _c("p", [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t(
                    "DELETE_NUMBER_POOL_MODAL_NUMBER_POOL_NONE_ASSOCIATION_TEXT"
                  )
                ) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasReferences
        ? _c("div", [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "DELETE_NUMBER_POOL_MODAL_NUMBER_POOL_ASSOCIATION_TEXT",
                      { numberPoolName: _vm.numberPool.name }
                    )
                  ) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "well well-sm m-t-10 m-b-0" }, [
              _c("div", { staticClass: "form-horizontal references-list" }, [
                _c("div", { staticClass: "row" }, [
                  _c("label", { staticClass: "col-md-3 control-label" }, [
                    _c("strong", [_vm._v("Campaigns")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-8" }, [
                    _c(
                      "ul",
                      {
                        staticClass:
                          "list-unstyled form-control-static list-text-overflow"
                      },
                      _vm._l(_vm.numberPoolReferences.campaigns, function(
                        campaign
                      ) {
                        return _c("li", { key: campaign.campaignId }, [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.right.hover",
                                  value: _vm.$t("VIEW_CAMPAIGN"),
                                  expression: "$t('VIEW_CAMPAIGN')",
                                  modifiers: { right: true, hover: true }
                                }
                              ],
                              attrs: {
                                href: `#/dashboard/campaign/${campaign.campaignId}`,
                                target: "_blank"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "display-text",
                                  attrs: { title: campaign.campaignName }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(campaign.campaignName) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa fa-external-link m-l-5"
                              })
                            ]
                          )
                        ])
                      }),
                      0
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "well well-sm m-t-10 m-b-0" }, [
        _c("div", { staticClass: "row form-horizontal" }, [
          _c(
            "div",
            { staticClass: "col-md-3" },
            [
              _c("NzToggle", {
                attrs: { name: "keepNumbers" },
                model: {
                  value: _vm.keepNumbers,
                  callback: function($$v) {
                    _vm.keepNumbers = $$v
                  },
                  expression: "keepNumbers"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "col-md-6 form-control-static" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "DELETE_NUMBER_POOL_CONFIRM_DEALLOCATION_KEEP_NUMBERS_TEXT"
                  )
                ) +
                "\n      "
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }